// @ts-nocheck
import getConfig from 'next/config';
import * as Env from '@scale/shared/environment';
import {
  SKIP_CATEGORIES,
  SKIP_REASONS,
  REPORT_CATEGORIES,
  REPORT_REASONS,
} from '@scale/shared/remotasks/constants';

export { SKIP_CATEGORIES, SKIP_REASONS, REPORT_CATEGORIES, REPORT_REASONS };

const config = getConfig();

function parseJSON(str, fallback = {}) {
  try {
    return JSON.parse(str);
  } catch (e) {
    return fallback;
  }
}

const viteConfig: Record<string, string> =
  typeof document === 'undefined'
    ? {}
    : parseJSON(document.getElementById('__CONFIG__')?.textContent);

function getNextOrEnvConfig(key) {
  return config?.publicRuntimeConfig?.[key] ?? process.env[key] ?? viteConfig[key];
}

// ENV VARS
export const OAUTH_SERVER_URL = getNextOrEnvConfig('OAUTH_SERVER_URL');
export const DEPLOYMENT = getNextOrEnvConfig('DEPLOYMENT');
export const DOMAIN = getNextOrEnvConfig('DOMAIN');
export const EXTREME_POINTS_CONFIG = parseJSON(getNextOrEnvConfig('EXTREME_POINTS_CONFIG'));
export const FACEBOOK_OAUTH_CLIENT_ID = getNextOrEnvConfig('FACEBOOK_OAUTH_CLIENT_ID');
export const NODE_ENV = getNextOrEnvConfig('NODE_ENV');
export const REMOTASKS_FRONTEND_URL = getNextOrEnvConfig('REMOTASKS_FRONTEND_URL');
export const REMOTASKS_FRONTEND_PROD_URL = getNextOrEnvConfig('REMOTASKS_FRONTEND_PROD_URL');
export const CRUISE_CONTROL_FRONTEND_URL = getNextOrEnvConfig('CRUISE_CONTROL_FRONTEND_URL');
export const CRUISE_CONTROL_FRONTEND_PROD_URL = getNextOrEnvConfig(
  'CRUISE_CONTROL_FRONTEND_PROD_URL',
);
export const WORKQUESTS_FRONTEND_URL = getNextOrEnvConfig('WORKQUESTS_FRONTEND_URL');
export const WORKQUESTS_API_URL = getNextOrEnvConfig('WORKQUESTS_API_URL');
export const WORKQUESTS_OAUTH_URL = getNextOrEnvConfig('WORKQUESTS_OAUTH_URL');
export const OUTLIER_FRONTEND_URL = getNextOrEnvConfig('OUTLIER_FRONTEND_URL');
export const OUTLIER_API_URL = getNextOrEnvConfig('OUTLIER_API_URL');
export const OUTLIER_OAUTH_URL = getNextOrEnvConfig('OUTLIER_OAUTH_URL');
export const SCALE_FRONTEND_URL = getNextOrEnvConfig('SCALE_FRONTEND_URL');
export const SCALE_FRONTEND_PROD_URL = getNextOrEnvConfig('SCALE_FRONTEND_PROD_URL');
export const SCALE_DASHBOARD_FRONTEND_URL = getNextOrEnvConfig('SCALE_DASHBOARD_FRONTEND_URL');
export const SCALE_DASHBOARD_FRONTEND_PROD_URL = getNextOrEnvConfig(
  'SCALE_DASHBOARD_FRONTEND_PROD_URL',
);
export const OPS_HUB_FRONTEND_URL = getNextOrEnvConfig('OPS_HUB_FRONTEND_URL');
export const IDENTITY_SERVICE_DASHBOARD_PASSWORD_LOGIN_URL = getNextOrEnvConfig(
  'IDENTITY_SERVICE_DASHBOARD_PASSWORD_LOGIN_URL',
);
export const IDENTITY_SERVICE_DASHBOARD_PASSWORD_REGISTER_LINK_URL = getNextOrEnvConfig(
  'IDENTITY_SERVICE_DASHBOARD_PASSWORD_REGISTER_LINK_URL',
);
export const IDENTITY_SERVICE_DASHBOARD_PASSWORD_REGISTER_NEXT_URL = getNextOrEnvConfig(
  'IDENTITY_SERVICE_DASHBOARD_PASSWORD_REGISTER_NEXT_URL',
);
export const QUICK_LINTER_SANDBOX_ENDPOINT = getNextOrEnvConfig('QUICK_LINTER_SANDBOX_ENDPOINT');
export const IDENTITY_SERVICE_DASHBOARD_PASSWORD_LOGIN_ENABLED = getNextOrEnvConfig(
  'IDENTITY_SERVICE_DASHBOARD_PASSWORD_LOGIN_ENABLED',
);
export const IDENTITY_SERVICE_ASSUME_PROFILE = getNextOrEnvConfig(
  'IDENTITY_SERVICE_ASSUME_PROFILE',
);
export const NEW_RELIC_APP_NAME = getNextOrEnvConfig('NEW_RELIC_APP_NAME');
export const NEXT_DIR = getNextOrEnvConfig('NEXT_DIR');
export const SEGMENT_KEY_CORP = getNextOrEnvConfig('SEGMENT_KEY_CORP');
export const SEGMENT_KEY_CUSTOMERS = getNextOrEnvConfig('SEGMENT_KEY_CUSTOMERS');
export const SEGMENT_KEY_SCALERS = getNextOrEnvConfig('SEGMENT_KEY_SCALERS');
export const SEGMENT_KEY_CONTRIBUTORS = getNextOrEnvConfig('SEGMENT_KEY_CONTRIBUTORS');
export const STRIPE_KEY = getNextOrEnvConfig('STRIPE_KEY');
export const APP_NAME = getNextOrEnvConfig('APP_NAME');
export const AWS_REGION = getNextOrEnvConfig('AWS_REGION');
export const STACK = getNextOrEnvConfig('STACK');
export const DATADOG_CLIENT_TOKEN = getNextOrEnvConfig('DATADOG_CLIENT_TOKEN');
export const DATADOG_RUM_CLIENT_TOKEN = getNextOrEnvConfig('DATADOG_RUM_CLIENT_TOKEN');
export const DATADOG_RUM_APP_ID = getNextOrEnvConfig('DATADOG_RUM_APP_ID');
export const REMOTASK_DATADOG_RUM_CLIENT_TOKEN = getNextOrEnvConfig(
  'REMOTASK_DATADOG_RUM_CLIENT_TOKEN',
);
export const REMOTASK_DATADOG_RUM_APP_ID = getNextOrEnvConfig('REMOTASK_DATADOG_RUM_APP_ID');
export const OPS_HUB_DATADOG_RUM_APP_ID = getNextOrEnvConfig('OPS_HUB_DATADOG_RUM_APP_ID');
export const OPS_HUB_DATADOG_RUM_CLIENT_TOKEN = getNextOrEnvConfig(
  'OPS_HUB_DATADOG_RUM_CLIENT_TOKEN',
);
export const OPS_HUB_DATADOG_RUM_SITE = getNextOrEnvConfig('OPS_HUB_DATADOG_RUM_SITE');
export const OPS_HUB_DATADOG_RUM_SERVICE = getNextOrEnvConfig('OPS_HUB_DATADOG_RUM_SERVICE');
export const MIST_DATADOG_RUM_APP_ID = getNextOrEnvConfig('MIST_DATADOG_RUM_APP_ID');
export const MIST_DATADOG_RUM_CLIENT_TOKEN = getNextOrEnvConfig('MIST_DATADOG_RUM_CLIENT_TOKEN');
export const MIST_DATADOG_RUM_SITE = getNextOrEnvConfig('MIST_DATADOG_RUM_SITE');
export const MIST_DATADOG_RUM_SERVICE = getNextOrEnvConfig('MIST_DATADOG_RUM_SERVICE');
export const SERVICE_NAME = getNextOrEnvConfig('SERVICE_NAME');
export const RECAPTCHA_SITE_KEY = getNextOrEnvConfig('RECAPTCHA_SITE_KEY');
export const USE_LITE_UI = getNextOrEnvConfig('USE_LITE_UI');
export const ONE_SCHEMA_WEBHOOK_KEY = getNextOrEnvConfig('ONE_SCHEMA_WEBHOOK_KEY');
export const SAPLING_API_KEY = getNextOrEnvConfig('SAPLING_API_KEY');
export const ALLOWED_ABSOLUTE_DOMAIN_ORIGIN = getNextOrEnvConfig('ALLOWED_ABSOLUTE_DOMAIN_ORIGIN');

// RUNTIME

export const IS_PROD = NODE_ENV === 'production';
export const IS_DEV = NODE_ENV === 'development';
export const IS_TEST = NODE_ENV?.toLowerCase() === 'test';
export const IS_E2E = NODE_ENV === 'production' && REMOTASKS_FRONTEND_URL?.includes('localhost');

// Federal deployments
export const IS_FEDERAL = Env.isFederal(DEPLOYMENT) || !!getNextOrEnvConfig('FED_DEBUG');
export const IS_SNOWFALL_OR_TETON = Env.isSnowfallOrTeton(DEPLOYMENT);
export const IS_FEDRAMP_HIGH = Env.isFedrampHigh(DEPLOYMENT);
export const IS_SNOWFALL = Env.isSnowfall(DEPLOYMENT);
export const IS_REDWOODS = Env.isRedwoods(DEPLOYMENT);
export const IS_TETON = Env.isTeton(DEPLOYMENT);
export const CLASSIFICATION = getNextOrEnvConfig('CLASSIFICATION');
export const JUPYTER_URL = getNextOrEnvConfig('JUPYTER_URL');
export const LOGIN_MODE = getNextOrEnvConfig('LOGIN_MODE');
export const UNIFIED_SAML_IDP_NAME = getNextOrEnvConfig('UNIFIED_SAML_IDP_NAME');
export const LAUNCH_SERVICE_KUBE_CONTEXT = getNextOrEnvConfig('LAUNCH_SERVICE_KUBE_CONTEXT');

export const CHAT_SERVICE_FRONTEND_CLIENT_MODE = IS_FEDRAMP_HIGH
  ? 'live'
  : getNextOrEnvConfig('CHAT_SERVICE_FRONTEND_CLIENT_MODE');
export const CHAT_SERVICE_FRONTEND_CLIENT_BASEPATH = IS_FEDRAMP_HIGH
  ? 'https://dashboard.scalegov.com/fractal/api'
  : getNextOrEnvConfig('CHAT_SERVICE_FRONTEND_CLIENT_BASEPATH');

export const AWS_SUFFIX = getNextOrEnvConfig('AWS_SUFFIX');
export const STATIC_ASSETS_BUCKET = getNextOrEnvConfig('STATIC_ASSETS_BUCKET');
export const CUSTOMER_S3_INTEGRATION_ROLE_NAME = 'ScaleAI-Integration';

export const INSTRUCTION_TASK_SKIP_CATEGORIES = {
  donotwant: "I don't want to work on this",
};

export const BAD_PRELABEL_TASK_SKIP_CATEGORIES = {
  prelabels: 'Prelabel quality',
};

export const NOT_EQUIPPED_SKIP_CATEGORIES = {
  notEquipped: 'Not equipped to answer',
};

export const NOT_EQUIPPED_SKIP_REASONS = {
  notEquipped: {
    only_choice: 'I am not equipped to answer this question',
  },
};

export const OSTRICH_MATH_SKIP_CATEGORIES = {
  irrecoverable: 'Irrecoverable',
  unfamiliarcategory: 'Unfamiliar category',
};

export const SKIP_BID_CATEGORIES = {
  bid: 'Task Price',
};

export const SKIP_BID_REASONS = {
  bid: {
    too_low: 'Price Too Low',
  },
};

// The true value of these strings are stored in locales/en/projectSection.json
export const PAUSE_CATEGORIES = {
  platform: 'remotasks-error',
  project: 'difficult-project',
  pay: 'pay',
};

export const PAUSE_REASONS = {
  platform: {
    task_loading: 'task-loading',
    instructions_loading: 'instructions-loading',
    error_submitting: 'error-submitting',
  },

  project: {
    edge_case: 'edge-case',
    image_quality: 'image-quality',
    task_difficulty: 'task-difficulty',
    qa_difficulty: 'qa-difficulty',
    task_length: 'task-length',
  },

  pay: {
    too_little: 'too-little',
    unpredictable: 'unpredictable',
  },
};
